module.exports = __webpack_public_path__ + "media/images/frontend/instagram-3c0f057cdd5c65d787e83a5079a2d1b3.svg";